import { WidgetsTypeEnum } from 'src/app/enums/widgets/widgets-type.enum';
import { WidgetsFieldModel } from './widgets-field.model';

export class WidgetsRadioModel extends WidgetsFieldModel {
  /**
   * Formly needs a unique key for each field. It's better human-friendly (id / uuid is not).
   * @remarks
   *
   * - For fields this is the key that will use in rendered forms for the model ('model.key')
   * - For questions/groups this defines the namespace for the fields that live inside ('model.groupkey.key').
   *
   * @author mgsg
   */

  readonly widgetType: WidgetsTypeEnum = WidgetsTypeEnum.RADIO;
  name: string = 'Radio';
  readonly badge: string = 'O';
  type: string = 'radio';         // input, radio, checkbox
  otherFlag: boolean = false;
  otherLabel?: string;
  deleteAllFlag: boolean = false;

  // toJSON() method as inherited from WidgetsFieldModel
  // cloneFrom() method as inherited from WidgetsFieldModel
}
